import { render, staticRenderFns } from "./Formulations.vue?vue&type=template&id=6305f0ca&"
import script from "./Formulations.vue?vue&type=script&lang=js&"
export * from "./Formulations.vue?vue&type=script&lang=js&"
import style0 from "./Formulations.vue?vue&type=style&index=0&id=6305f0ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports